import * as React from "react";
import { useIntl } from "@grandvisionhq/state";
import { IMAGE_QUERY_PARAMS } from "../../../../constants/constants/constants.js";
import { useGetOrderByToken } from "../../../../hooks/getOrderByToken/hooks/getOrderByToken/use-get-order-by-token.js";
import { toDonationIntent, toOrderDetailPrice, toServiceStore, toInvoice, toAddress, toOrderDetailsPaymentInfo, toOrderDeliveryMethod, toCustomerDetails } from "../../../../mappers/mappers/orders.js";
import { toOrderLineItem } from "../../../../mappers/line-item/mappers/line-item/order-line-item.js";
import { getShipmentStatusLabel } from "../../../../mappers/utils/mappers/utils/get-shipment-status-label.js";
import { getPaymentMethodLabel, labelKeySuffixes } from "../../../../mappers/utils/mappers/utils/get-payment-method-label.js";
import "@grandvisionhq/utils";
import "@grandvisionhq/graphql";
import { getDeliveryEstimation } from "../../../../mappers/utils/mappers/utils/get-delivery-estimation.js";
import { LoyaltyCardType } from "../../../../models/models/details-order.js";
import { OrderContext } from "./context.js";
const OrderProvider = ({ children }) => {
  const [getOrderByToken, { called, loading, data, error }] = useGetOrderByToken();
  const intl = useIntl();
  const options = React.useMemo(
    () => ({
      imageQueryParams: IMAGE_QUERY_PARAMS
    }),
    []
  );
  const order = React.useMemo(() => {
    if (data === null) {
      return null;
    }
    if (!data) {
      return void 0;
    }
    const order2 = data.getOrderByToken;
    const deliveryDates = order2.shippingInfo.expectedDeliveryEstimation?.__typename === "RangeEstimation" ? {
      minDeliveryDate: order2.shippingInfo.expectedDeliveryEstimation.deliveryRange.min,
      maxDeliveryDate: order2.shippingInfo.expectedDeliveryEstimation.deliveryRange.max
    } : void 0;
    return {
      loyaltyDetails: order2.loyaltyDetails ? {
        points: order2.loyaltyDetails.points,
        cardNumber: order2.loyaltyDetails.cardNumber || "",
        cardNumberType: order2.loyaltyDetails.cardNumberType ? LoyaltyCardType[order2.loyaltyDetails.cardNumberType] : null
      } : void 0,
      checkoutId: order2.checkoutId,
      customerDetails: toCustomerDetails(order2.customerDetails),
      billingAddress: toAddress(order2.billingAddress),
      hasSubscription: order2.hasSubscription || false,
      deliveryMethod: toOrderDeliveryMethod(order2.shippingInfo),
      lineItems: order2.lineItems.map(
        (lineItem) => toOrderLineItem(lineItem, intl, options)
      ),
      rawLineItems: order2.lineItems.map((item) => item),
      orderDate: new Date(order2.orderDate),
      orderNumber: order2.orderNumber,
      paymentMethodKey: labelKeySuffixes[order2.paymentMethod],
      paymentMethod: getPaymentMethodLabel(order2.paymentMethod, intl),
      paymentDetails: toOrderDetailsPaymentInfo(order2.payments),
      paymentStatus: order2?.paymentStatus ?? "",
      receiptUrl: order2.receiptUrl ?? void 0,
      shipmentStatus: getShipmentStatusLabel(order2.shipmentStatus, intl),
      shipmentTrackingUrl: order2.shipmentTrackingURL ?? void 0,
      shippingAddress: toAddress(order2.shippingAddress),
      shippingInfo: deliveryDates,
      invoice: toInvoice(order2.invoiceDetails),
      serviceStore: toServiceStore(order2.serviceStore),
      ...toOrderDetailPrice(order2.price),
      discountCodes: order2.discountCodes ? order2.discountCodes.map((item) => ({
        code: item.code,
        name: item.name ? item.name.map((discountNameItem) => ({
          locale: discountNameItem.locale,
          value: discountNameItem.value
        })) : []
      })) : [],
      deliveryEstimationMessage: getDeliveryEstimation(order2.shippingInfo, intl),
      donationIntent: toDonationIntent(order2.payments)
    };
  }, [data, intl, options]);
  const value = React.useMemo(
    () => ({ order, loading, error, called, getOrderByToken }),
    [order, loading, error, called, getOrderByToken]
  );
  if (typeof children === "function") {
    return /* @__PURE__ */ React.createElement(OrderContext.Provider, { value }, children(value));
  }
  return /* @__PURE__ */ React.createElement(OrderContext.Provider, { value }, children);
};
export {
  OrderProvider
};
//# sourceMappingURL=provider.js.map
